import { Component, Input } from '@angular/core';

@Component({
    selector: 'c-pdf-viewer',
    templateUrl: './pdf-viewer.component.html',
    styleUrl: './pdf-viewer.component.css',
    standalone: false
})
export class PdfViewerComponent {
  @Input() url!: string;
  visible = false;

  show(url: string) {
    this.url = url;
    this.visible = true;
  }

  close() {
    this.url = '';
    this.visible = false;
  }
}
